import React from "react";
import clsx from "clsx";

type InputHelperProps = React.HTMLAttributes<HTMLDivElement> & {
  text: string;
};

const InputHelper = ({ text, className, ...props }: InputHelperProps) => {
  return (
    <p className={clsx("text-sm text-tertiary", className)} {...props}>
      {text}
    </p>
  );
};

export default InputHelper;
